import { render, staticRenderFns } from "./RelatorioAniversariantes.vue?vue&type=template&id=2aafac1a"
import script from "./RelatorioAniversariantes.vue?vue&type=script&lang=js"
export * from "./RelatorioAniversariantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports